import React from "react";
import Retweet from "./Components/index";
import { fromMonthly, toMonthly } from "fuction/date";
import { withRouter } from "react-router";
import queryString from "query-string";
import useFilter from "Hooks/useFilter";
import useAuth from "Hooks/useAuth";

function Page(props) {
  const filter = useFilter();
  const auth = useAuth();
  const { id } = queryString.parse(props.location.search);

  const fromDate = fromMonthly(filter.state.filteredDateFrom);
  const toDate = toMonthly(filter.state.filteredDateTo);
  const activeGroup = auth.state.activeGroup;
  const onClickLineChart = (date) => {
    props.history.push(`/retweets/daily?activeGroup=${activeGroup}&id=${id}&date=${date}`);
  };

  return (
    <Retweet
      fromDate={fromDate}
      toDate={toDate}
      id={id}
      target="monthly"
      unit="date"
      onClickLineChart={onClickLineChart}
    />
  );
}

export default withRouter(Page);
